import { useEffect, useRef, useState } from 'react';
import { maybeRedirectForSsoRetry } from './ssoRetryRedirect.js';
/**
 * S-91 第2弾: 素リンク SSO 到着でセッションが失効していた場合に、サインイン画面へ
 * 落とす代わりに portal へ `?sso_retry` bounce して自動復帰する状態機械。
 * tenant-reservation / tenant-fuel / tenant-promo の AuthGuard で共有する。
 *
 * **明示サインアウトとの区別（critical）**: bounce は「このページに signed-out で到着した」
 * ケース（= 素リンク遷移でセッションが無かった）だけで発動させる。ページ滞在中に
 * ユーザーが自分でサインアウトした（一度 signed-in を観測してから signed-out へ遷移した）
 * 場合は bounce しない — さもないと signOut が portal 経由の自動再サインインに化けて
 * サインアウトが成立しなくなる。
 *
 * @returns 'pending'（判定前の 1 フレーム）/ 'bouncing'（redirect の離脱待ち）/
 *   'none'（bounce しない = 呼出側は通常どおり /signin へ）
 */
export function useSsoRetryBounce(opts) {
    const { feature, portalUrl, allowedReferrerOrigins, status } = opts;
    const [state, setState] = useState('pending');
    // このページ生存中に一度でも signed-in を観測したか（= 明示サインアウト経路の判定）。
    const wasSignedIn = useRef(false);
    useEffect(() => {
        if (status === 'signed-in') {
            wasSignedIn.current = true;
            return;
        }
        if (status !== 'signed-out')
            return;
        // 一度 signed-in だった → ユーザーの明示サインアウト。bounce しない。
        if (wasSignedIn.current) {
            setState('none');
            return;
        }
        setState(maybeRedirectForSsoRetry({ feature, portalUrl, allowedReferrerOrigins })
            ? 'bouncing'
            : 'none');
    }, [status, feature, portalUrl, allowedReferrerOrigins]);
    return state;
}
//# sourceMappingURL=useSsoRetryBounce.js.map